import type {
  HandlersDevSignCmsRequest,
  HandlersDevSignCmsResponse,
} from '../app/athenaApiGen';
import type { MintArgs, MintedCMS, Signer } from './types';

export type DevSignCmsTrigger = (
  req: HandlersDevSignCmsRequest,
) => Promise<HandlersDevSignCmsResponse>;

export function createDevSigner(trigger: DevSignCmsTrigger): Signer {
  return {
    async sign(args: MintArgs): Promise<MintedCMS> {
      const resp = await trigger({
        workflowId: args.workflowId,
        taskNumber: args.taskNumber,
        action: args.action,
        comments: args.comments,
      });
      if (!resp.cms || !resp.payloadDigest) {
        throw new Error('dev sign-cms response missing cms or payloadDigest');
      }
      return {
        cms: resp.cms,
        payloadDigest: resp.payloadDigest,
        payloadType: resp.payloadType ?? 'workflow-task-action',
      };
    },
  };
}
